import {LED_SELECTORS} from '../floorplan/utils/consts';
import {
	DATAPOINT_BUTTON1,
	DATAPOINT_BUTTON2,
	DATAPOINT_BUTTON_COLOR1,
	DATAPOINT_BUTTON_COLOR2
} from '../../../modules/common/consts';
import type {ButtonInfo} from '../floorplan/types';
import {WidgetSvg} from '../floorplan/hooks/types';
import {DeviceType} from '../../../modules/ruleengine/config/consts';
import sBoxSvg from '../floorplan/config/svgs/sBoxSvg';
import sLightSvg from '../floorplan/config/svgs/sLightModified';
import kisIoSvg from '../floorplan/config/svgs/kisIoSvg';

const addButtonInteractivity = (
	svgRootObj: WidgetSvg,
	assetIdString: string,
	canPressButton: boolean,
	setButtonInfo: (arg0: ButtonInfo) => void
) => {
	const button1 = svgRootObj.select(LED_SELECTORS[DATAPOINT_BUTTON_COLOR1]) as WidgetSvg;
	const button2 = svgRootObj.select(LED_SELECTORS[DATAPOINT_BUTTON_COLOR2]) as WidgetSvg;

	if (canPressButton) {
		const release1Func = () => {
			setButtonInfo({
				assetId: assetIdString,
				dataPointName: DATAPOINT_BUTTON1
			});
		};

		button1.on('click', release1Func);
		button1.on('touchend', release1Func);

		const release2Func = () => {
			setButtonInfo({
				assetId: assetIdString,
				dataPointName: DATAPOINT_BUTTON2
			});
		};

		button2.on('click', release2Func);
		button2.on('touchend', release2Func);
		const hasTheClassOne = button1.members[0].hasClass('sbox-button');
		const hasTheClassTwo = button2.members[0].hasClass('sbox-button');

		if (!hasTheClassOne) {
			button1.addClass('sbox-button');
		}

		if (!hasTheClassTwo) {
			button2.addClass('sbox-button');
		}
	} else {
		if (button1.members[0].hasClass('sbox-button')) {
			button1.toggleClass('sbox-button');
		}

		if (button2.members[0].hasClass('sbox-button')) {
			button2.toggleClass('sbox-button');
		}
	}
};

const getSvgByDeviceType = (deviceType: DeviceType): string => {
	switch (deviceType) {
		case DeviceType.sBox:
			return sBoxSvg;
		case DeviceType.sLight:
			return sLightSvg;
		case DeviceType.kisIo:
			return kisIoSvg;
	}
};

export {addButtonInteractivity, getSvgByDeviceType};
